import React, { useState, useEffect } from "react";
import { currentDateFormat, dateFormat } from "../utils";
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
} from "@mui/material";
import { School } from "@mui/icons-material";
import groupDriver from "../assets/images/group-driver.png";
import axios from "axios";
import {
  GET_DRIVERS_COUNT,
  GET_SCHEDULE_COUNT,
  GET_VEHICLE_COUNT,
  GET_MAINTENANCE_VEHICLE_COUNT,
  GET_UPCOMING_SCHEDULE,
  GET_TRIP_DETAILS,
  GET_TODAYS_TRIP_DETAILS,
  GET_TOMARROW_SCHEDULE,
  BILL_DETAILS,
  GET_DRIVER_LIST,
  ADD_SCHEDULE_DRIVER,
} from "../constant";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../redux/loaderAction";
import { Base64 } from "js-base64";
import MultipleMapComponent from "../components/MultipleMapComponent";
import ReusableModal from "../components/ModalContent/ReusableModal";
import DefaultProfileImage from "../assets/images/default-profile-img.png";
import totalBillAmount from "../assets/images/total_bill.png";
import totalAmountReceive from "../assets/images/total_amount_receive.png";
import totalAmountPending from "../assets/images/total_pending.png";
import totalAmountDenied from "../assets/images/total_denied.png";
import filter from "../assets/images/filter.png";
import DatePicker from "react-datepicker";
import { useNavigate } from "react-router-dom";
import moment from "moment";
//import Swal from '../../node_modules/sweetalert2/dist/sweetalert2';
import Swal from "../messageBox/customSweetAlert";
import DriverListModal from "../components/ModalContent/DriverListModal";

function DashboardNew() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currentDate, setCurrentDate] = useState(new Date());
  const [drversCount, setDrivresCount] = useState(0);
  const [todayScheduleCount, setTodayScheduleCount] = useState(0);
  const [totalVehicleCount, setTotalVehicleCount] = useState(0);
  const [maintenanceVehicle, setMaintenanceVehicle] = useState("");
  const [scheduleDetails, setScheduleDetails] = useState();
  const [route, setRoute] = useState();
  const [tripPendingCount, setTripPendingCount] = useState(0);
  const [tripProgressCount, setTripProgressCount] = useState(0);
  const [tripCompletedCount, setTripCompletedCount] = useState(0);
  const [tripsTotalAmount, setTripsTotalAmount] = useState(0);
  const [selectedButton, setSelectedButton] = useState("today");
  const [totalAmountBilled, setTotalAmountBilled] = useState(0);
  const [totalAmountReceived, setTotalAmountReceived] = useState(0);
  const [totalPendingAmount, setTotalAmountPending] = useState(0);
  const [totalDeniedAmount, setTotalAmountDenied] = useState(0);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [tripCancelCount, setTripCancelCount] = useState(0);
  const [isModalVisible, setModalVisible] = useState(false);
  const [selectedScheduleId, setSelectedScheduleId] = useState();
  const [selectedScheduleDate, setSelectedScheduleDate] = useState(null);
  const [error, setError] = useState(false);
  const [driverList, setDriverList] = useState([]);
  const [selectedDriverId, setSelectedDriverId] = useState(null);
  const [isClicked, setIsClicked] = useState(false);
  const [scheduleList, setScheduleList] = useState([]);
  const [currentDateFilterData, setCurrentDateFilterData] = useState([]);
  const { isVisible } = useSelector((state) => state.modal.isVisible);

  const toggleFilter = () => {
    setIsFilterVisible(!isFilterVisible);
  };

  const loadUser = async (type) => {
    dispatch(setLoading(true));
    const end = moment(); // today
    const start = moment().subtract(1, "months"); // one month before

    setToDate(end.toDate());
    setFromDate(start.toDate());

    try {
      // Determine schedule endpoint based on type
      let scheduleUrl = null;
      if (type === "today") {
        scheduleUrl = GET_UPCOMING_SCHEDULE;
      } else if (type === "yesterday") {
        scheduleUrl = GET_TOMARROW_SCHEDULE;
      }

      const [
        response_1, // drivers count
        response_2, // schedule count
        response_3, // vehicle count
        response_4, // maintenance vehicle
        response_5, // upcoming / tomorrow schedule (may be null)
        response_6, // trip details
        response_7, // today's trip details
        response_8, // billing
        response_9, // driver list
      ] = await Promise.all([
        axios.get(GET_DRIVERS_COUNT),
        axios.get(GET_SCHEDULE_COUNT),
        axios.get(GET_VEHICLE_COUNT),
        axios.get(GET_MAINTENANCE_VEHICLE_COUNT),
        scheduleUrl ? axios.get(scheduleUrl) : Promise.resolve({ data: [] }),
        axios.get(GET_TRIP_DETAILS),
        axios.get(GET_TODAYS_TRIP_DETAILS),
        axios.post(BILL_DETAILS),
        axios.get(GET_DRIVER_LIST),
      ]);

      setDriverList(response_9.data);
      setDrivresCount(response_1.data);
      setTodayScheduleCount(response_2.data);
      setTotalVehicleCount(response_3.data);
      setScheduleDetails(response_5.data);
      setRoute(response_6.data);
      setTripPendingCount(response_7.data?.data?.schedulePendingCount);
      setTripCancelCount(response_7.data?.data?.scheduleCancelCount ?? "");
      setTripProgressCount(
        response_7.data?.data?.TripsCounts[0]?.progressTripsCount
      );
      setTripCompletedCount(
        response_7.data?.data?.TripsCounts[0]?.completedTripsCount
      );
      setTripsTotalAmount(response_7.data?.data?.sumOfTripAmnt);
      setTotalAmountBilled(response_8.data?.data?.totalBillAmount ?? 0);
      setTotalAmountReceived(response_8.data?.data?.totalReceiveAmount ?? 0);
      setTotalAmountPending(response_8.data?.data?.totalPendingAmount ?? 0);
      setTotalAmountDenied(response_8.data?.data?.totalDeniedAmount ?? 0);

      const questionlist = response_4.data.data.questionsList;

      const groupedByVehicle = {};

      response_4.data.data.result.forEach((vehicle) => {
        const vehicleId = vehicle.vehicle_id;
        const dateString = vehicle.inspection_date.replace(/"/g, "");
        const currentDate = moment.utc(dateString);

        // Keep the latest inspection per vehicle using moment (handles same date with different times)
        if (
          !groupedByVehicle[vehicleId] ||
          currentDate.isAfter(
            moment.utc(
              groupedByVehicle[vehicleId].inspection_date.replace(/"/g, "")
            )
          )
        ) {
          groupedByVehicle[vehicleId] = vehicle;
        }
      });

      const vehiclesNeedingMaintenance = Object.values(groupedByVehicle)
        .map((vehicle) => {
          let components;

          try {
            const parsedOnce = JSON.parse(vehicle?.component);
            components =
              typeof parsedOnce === "string"
                ? JSON.parse(parsedOnce)
                : parsedOnce;
          } catch (err) {
            return null;
          }

          const failedComponents = components.filter(
            (c) => c.answer == "2" || c.answer == "3"
          );

          if (failedComponents.length > 0) {
            return {
              vehicle_name: vehicle.vehicleDetails.vehicle_name,
              vehicle_id: vehicle.vehicle_id,
              last_update_date: vehicle.inspection_date,
              questions: failedComponents.map((c) => ({
                question: questionlist[c.questionId - 1] || c.questionId,
                status: c.answer == "2" ? "Requires Attention" : "Needs Repair",
              })),
            };
          }

          return null; // Skip vehicles with no failed components
        })
        .filter(Boolean)
        .sort((a, b) =>
          moment
            .utc(b.last_update_date.replace(/"/g, ""))
            .diff(moment.utc(a.last_update_date.replace(/"/g, "")))
        );

      setMaintenanceVehicle(vehiclesNeedingMaintenance);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
      dispatch(setLoading(false));
    }
  };

  useEffect(() => {
    loadUser("today");
  }, []);

  const driverSaveForm = async () => {
    setIsClicked(true);
    try {
      if (selectedDriverId) {
        const response = await axios.post(ADD_SCHEDULE_DRIVER, {
          scheduleId: selectedScheduleId,
          driverId: selectedDriverId,
          scheduleDate: selectedScheduleDate,
        });
        if (response.data.status === "200") {
          setIsClicked(false);
          Swal.fire({
            title: "Success!",
            text: response.data.message,
            icon: "success",
            confirmButtonText: "OK",
          });
          const assignDriver = driverList.find(
            (driver) => driver.user_id === selectedDriverId
          );
          setSelectedDriverId();
          setModalVisible(isVisible);

          setScheduleDetails((prev) => {
            return prev.map((item) =>
              item.schedule_id === selectedScheduleId
                ? {
                  ...item,
                  driver: {
                    firstName: assignDriver.first_name,
                    middleName: assignDriver.middle_name,
                    lastName: assignDriver.last_name,
                    fullName: assignDriver.full_name,
                    driver_id: assignDriver.user_id,
                  },
                }
                : item
            );
          });
          setScheduleList((prev) => {
            return prev.map((item) =>
              item.schedule_id === selectedScheduleId
                ? {
                  ...item,
                  driver: {
                    firstName: assignDriver?.first_name,
                    middleName: assignDriver?.middle_name,
                    lastName: assignDriver?.last_name,
                    full_name: assignDriver?.full_name,
                  },
                }
                : item
            );
          });
        } else {
          setIsClicked(false);
          Swal.fire({
            title: "Failed!",
            text: response.data.message,
            icon: "Warning",
            confirmButtonText: "OK",
          });
        }
      } else {
        setIsClicked(false);
        Swal.fire({
          title: "Failed!",
          text: "Please select a driver",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      setIsClicked(false);
      console.error("Error logging in:", error);
    }
  };

  const handleButtonClick = (button) => {
    setSelectedButton(button); // Update the selected button
    loadUser(button);
  };

  const [openPopup, setOpenPopup] = useState(false);
  const [popupData, setPopupData] = useState(null);

  const handleOpenPopup = (data) => {
    setPopupData(data);
    setOpenPopup(true);
  };

  const handleClosePopup = () => {
    setOpenPopup(false);
    setPopupData(null);
  };

  const searchBillingData = async () => {
    setIsLoading(true); // Show loader

    if (Object.keys(errors).length > 0) {
      setIsLoading(false); // Hide loader if there are errors
      Swal.fire({
        title: "Failed",
        text: "Start date must be earlier than the end date.",
        icon: "error",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
      return false;
    }
    try {
      const response = await axios.post(BILL_DETAILS, { fromDate, toDate });
      const data = response.data;

      setTotalAmountBilled(response.data?.data?.totalBillAmount ?? 0);
      setTotalAmountReceived(response.data?.data?.totalReceiveAmount ?? 0);
      setTotalAmountPending(response.data?.data?.totalPendingAmount ?? 0);
      setTotalAmountDenied(response.data?.data?.totalDeniedAmount ?? 0);
      setIsLoading(false);
    } catch (error) {
      console.error("Error searching billing data:", error);
    } finally {
      setIsLoading(false); // Hide loader
    }
  };
  const openModal = (scheduleId, scheduleDate) => {
    //alert(scheduleDate);
    const scheduledate = new Date(scheduleDate);
    const todayDate = new Date();

    setModalVisible(true);
    setSelectedScheduleId(scheduleId);
    setSelectedScheduleDate(scheduleDate);
    //}
  };

  const closeModal = () => {
    setModalVisible(false);
    setError(false); // Reset error state when modal is closed
  };

  return (
    <>
      <section className="pl-5 pr-5" style={{ marginTop: "0px" }}>
        <div
          className="d-flex justify-content-between form-container"
          style={{ borderBottom: "solid 1px #eee" }}
        >
          <div>
            <h2 className="fs-5 font-weight-600">Dashboard </h2>
          </div>
          <div>
            <span style={{ fontSize: "15px" }}>
              {currentDateFormat(currentDate)}
            </span>
          </div>
        </div>
      </section>
      <div className="container-fluid px-mobile-2  px-5">
        <section>
          <div className="row">
            <div className="col-md-7" style={{ padding: "0px 10px 8px 8px" }}>
              {/* <label style={{ display: "block" }}>&nbsp;</label> */}
              <div
                style={{
                  color: "#31876f",
                  fontSize: "16px",
                  padding: "0px",
                  lineHeight: "1.6",
                }}
              >
                Billing Details
              </div>
            </div>

            <div
              className="col-md-6"
              style={{ padding: "10px", display: "none" }}
            >
              <div className="row">
                <div className="col-md-5">
                  <label style={{ display: "block" }}>Start Date</label>
                  <DatePicker
                    selected={fromDate}
                    onChange={(date) => {
                      if (toDate && date > toDate) {
                        setErrors({
                          from_date: "From date greater than To date",
                        });
                      } else {
                        setErrors({});
                      }
                      setFromDate(date);
                    }}
                    dateFormat="MM/dd/yyyy"
                    autoComplete="off"
                    className="datepicker form-control hasDatepicker"
                    id="from_date"
                    name="from_date"
                  />
                  {/* <div style={{ color: 'red' }}>
                    {errors.from_date && <span className="errors">{errors.from_date}</span>}
                  </div> */}
                </div>

                <div className="col-md-5">
                  <label style={{ display: "block" }}>End Date</label>
                  <DatePicker
                    selected={toDate}
                    onChange={(date) => {
                      if (fromDate && date < fromDate) {
                        setErrors({ to_date: "To date less than From date" });
                      } else {
                        setErrors({});
                      }
                      setToDate(date);
                    }}
                    dateFormat="MM/dd/yyyy"
                    autoComplete="off"
                    className="datepicker form-control hasDatepicker"
                    id="to_date"
                    name="to_date"
                  />
                  {/* <div style={{ color: 'red' }}>
                    {errors.to_date && <span className="errors">{errors.to_date}</span>}
                  </div> */}
                </div>
                <div className="col-md-2">
                  <label style={{ display: "block", visibility: "hidden" }}>
                    Search
                  </label>
                  {isLoading ? (
                    <button
                      type="button"
                      style={{
                        background: "#082f49",
                        border: "unset",
                        height: "38px",
                        color: "#fff",
                        padding: "7px",
                      }}
                      onClick={searchBillingData}
                    >
                      SEARCH
                    </button>
                  ) : (
                    <button
                      type="button"
                      style={{
                        background: "#082f49",
                        border: "unset",
                        height: "38px",
                        color: "#fff",
                        padding: "7px",
                      }}
                      onClick={searchBillingData}
                    >
                      SEARCH
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="row align-items-center mb-4">
            <div
              className="col-sm-12 col-lg-12"
              style={{ marginBottom: "11px", display: "none" }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "16px",
                }}
              >
                <div
                  style={{
                    color: "#31876f",
                    fontSize: "24px",
                    padding: "0px",
                    lineHeight: "1.6",
                  }}
                >
                  Billing Details
                </div>

                {/* Right Side: Filter Section */}
                <div className="schedule-filter d-flex">
                  <div>
                    <div className="me-2">
                      <label style={{ display: "block" }}>Start Date</label>
                      <DatePicker
                        selected={fromDate}
                        onChange={(date) => {
                          console.log(date, toDate);
                          if (toDate && date > toDate) {
                            console.log("From date greater than To date");
                            setErrors({
                              from_date: "From date greater than To date",
                            });
                          } else {
                            setErrors({});
                          }
                          setFromDate(date);
                        }}
                        dateFormat="MM/dd/yyyy"
                        autoComplete="off"
                        className="datepicker form-control hasDatepicker"
                        id="from_date"
                        name="from_date"
                      />
                    </div>
                    <div className="error-message">
                      {errors.from_date && (
                        <span className="errors">{errors.from_date}</span>
                      )}
                    </div>
                  </div>
                  <div>
                    <div className="me-2">
                      <label style={{ display: "block" }}>End Date</label>
                      <DatePicker
                        selected={toDate}
                        onChange={(date) => {
                          if (fromDate && date < fromDate) {
                            setErrors({
                              to_date: "To date less than From date",
                            });
                          } else {
                            setErrors({});
                          }
                          setToDate(date);
                        }}
                        dateFormat="MM/dd/yyyy"
                        autoComplete="off"
                        className="datepicker form-control hasDatepicker"
                        id="to_date"
                        name="to_date"
                      />
                    </div>
                    <div className="error-message">
                      {errors.to_date && (
                        <span className="errors">{errors.to_date}</span>
                      )}
                    </div>
                  </div>
                  <div>
                    <label style={{ display: "block", visibility: "hidden" }}>
                      Search
                    </label>
                    {isLoading ? (
                      <button
                        type="button"
                        style={{
                          background: "#31876f",
                          border: "unset",
                          height: "38px",
                          color: "#fff",
                          padding: "7px",
                          cursor: "not-allowed",
                        }}
                        disabled
                      >
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Loading...
                      </button>
                    ) : (
                      <button
                        type="button"
                        style={{
                          background: "#31876f",
                          border: "unset",
                          height: "38px",
                          color: "#fff",
                          padding: "7px",
                        }}
                        onClick={searchBillingData}
                      >
                        SEARCH
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div style={{ display: "none" }}>
              <div className="col-sm-6 col-md-3 col-lg-3 mb-4">
                {/* <Link to="/home/driver/list" style={{ textDecoration: 'none' }}> */}
                <Card
                  className="item-box"
                  style={{
                    minWidth: 200,
                    maxWidth: 300,
                    backgroundColor: "#30876a",
                    height: "126px",
                  }}
                >
                  <CardContent
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <img src={totalBillAmount} style={{ width: "70px" }} />
                    <div>
                      <Typography
                        variant="h6"
                        component="div"
                        className="box-text-size"
                        style={{ color: "#fff", paddingLeft: "22px" }}
                      >
                        Total Amount Billed
                      </Typography>
                      <Typography
                        variant="h4"
                        component="div"
                        style={{
                          color: "#fff",
                          marginLeft: "17px",
                          textAlign: "left",
                          marginTop: "5px",
                        }}
                      >
                        {"$" + totalAmountBilled}
                      </Typography>
                    </div>
                  </CardContent>
                </Card>
                {/* </Link> */}
              </div>
              <div className="col-sm-6 col-md-3 col-lg-3 mb-4">
                {/* <Link to="/home/schedule/list" style={{ textDecoration: 'none' }}> */}
                <Card
                  className="item-box"
                  style={{
                    minWidth: 200,
                    maxWidth: 300,
                    backgroundColor: "#30876a",
                    height: "126px",
                  }}
                >
                  <CardContent
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <img src={totalAmountReceive} style={{ width: "70px" }} />
                    <div>
                      <Typography
                        variant="h6"
                        className="box-text-size"
                        component="div"
                        style={{ color: "#fff", paddingLeft: "10px" }}
                      >
                        Total Amount Received
                      </Typography>
                      <Typography
                        variant="h4"
                        component="div"
                        style={{
                          color: "#fff",
                          marginLeft: "17px",
                          textAlign: "left",
                          marginTop: "5px",
                        }}
                      >
                        {"$" + totalAmountReceived}
                      </Typography>
                    </div>
                  </CardContent>
                </Card>
                {/* </Link> */}
              </div>

              <div className="col-sm-6 col-md-3 col-lg-3 mb-4">
                {/* <Link to="/home/vehicle/list" style={{ textDecoration: 'none' }}> */}
                <Card
                  className="item-box"
                  style={{
                    minWidth: 200,
                    maxWidth: 300,
                    backgroundColor: "#30876a",
                    height: "126px",
                  }}
                >
                  <CardContent
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <img src={totalAmountPending} style={{ width: "70px" }} />
                    <div>
                      <Typography
                        variant="h6"
                        className="box-text-size"
                        component="div"
                        style={{ color: "#fff", paddingLeft: "30px" }}
                      >
                        Total Amount Pending
                      </Typography>
                      <Typography
                        variant="h4"
                        component="div"
                        style={{
                          color: "#fff",
                          marginLeft: "17px",
                          textAlign: "left",
                          marginTop: "5px",
                        }}
                      >
                        {"$" + totalPendingAmount}
                      </Typography>
                    </div>
                  </CardContent>
                </Card>
                {/* </Link> */}
              </div>
              <div className="col-sm-6 col-md-3 col-lg-3 mb-4">
                {/* <Link to="/home/schedule/list" style={{ textDecoration: 'none' }}> */}
                <Card
                  className="item-box"
                  style={{
                    minWidth: 200,
                    maxWidth: 300,
                    backgroundColor: "#30876a",
                    height: "126px",
                  }}
                >
                  <CardContent
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <img src={totalAmountDenied} style={{ width: "70px" }} />
                    <div>
                      <Typography
                        variant="h6"
                        className="box-text-size"
                        component="div"
                        style={{ color: "#fff", paddingLeft: "10px" }}
                      >
                        Total Amount Denied
                      </Typography>
                      <Typography
                        variant="h4"
                        component="div"
                        style={{
                          color: "#fff",
                          marginLeft: "17px",
                          textAlign: "left",
                          marginTop: "5px",
                        }}
                      >
                        {"$" + totalDeniedAmount}
                      </Typography>
                    </div>
                  </CardContent>
                </Card>
                {/* </Link> */}
              </div>
            </div>
            <section>
              <div class="billing-search-container">
                <div class="billing-summary">
                  <div class="summary-card total-billed">
                    <h3>Total Amount Billed</h3>
                    <div class="amount">{`$${totalAmountBilled}`}</div>
                    {/* <div class="amount">{`$${100}`}</div> */}
                  </div>
                  <div class="summary-card amount-received">
                    <h3>Total Amount Received</h3>
                    <div class="amount">{`$${totalAmountReceived}`}</div>
                  </div>
                  <div class="summary-card amount-pending">
                    <h3>Total Amount Pending</h3>
                    <div class="amount">{`$${totalPendingAmount}`}</div>
                  </div>
                  <div class="summary-card amount-denied">
                    <h3>Total Amount Denied</h3>
                    <div class="amount">{`$${totalDeniedAmount}`}</div>
                  </div>
                </div>

                <div className="search-section">
                  <form className="search-form" id="searchForm">
                    <div className="form-group search-h3">
                      <h3>Start Date</h3>
                      <DatePicker
                        selected={fromDate}
                        onChange={(date) => {
                          if (toDate && date > toDate) {
                            setErrors({
                              from_date: "From date greater than To date",
                            });
                          } else {
                            setErrors({});
                          }
                          setFromDate(date);
                        }}
                        dateFormat="MM/dd/yyyy"
                        autoComplete="off"
                        className="datepicker form-control hasDatepicker"
                        id="from_date"
                        name="from_date"
                      />
                      <div className="error-message error-width">
                        {errors.from_date && (
                          <span className="errors">{errors.from_date}</span>
                        )}
                      </div>
                    </div>
                    <div className="form-group search-h3">
                      <h3>End Date</h3>
                      <DatePicker
                        selected={toDate}
                        onChange={(date) => {
                          if (fromDate && date < fromDate) {
                            setErrors({
                              to_date: "To date less than From date",
                            });
                          } else {
                            setErrors({});
                          }
                          setToDate(date);
                        }}
                        dateFormat="MM/dd/yyyy"
                        autoComplete="off"
                        className="datepicker form-control hasDatepicker"
                        id="to_date"
                        name="to_date"
                      />
                      <div className="error-message error-width">
                        {errors.to_date && (
                          <span className="errors">{errors.to_date}</span>
                        )}
                      </div>
                    </div>
                    <div className="form-group" style={{ marginBottom: "3px" }}>
                      {isLoading ? (
                        <button
                          type="button"
                          className="search-btn"
                          disabled
                          style={{
                            minWidth: "86px",
                            height: "38px",
                            width: "80px",
                          }}
                        >
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        </button>
                      ) : (
                        <button
                          type="button"
                          onClick={searchBillingData}
                          className="search-btn"
                          style={{
                            minWidth: "86px",
                            height: "38px",
                            width: "80px",
                          }}
                        >
                          Search
                        </button>
                      )}
                      {/* <button type="button" onClick={searchBillingData} className="search-btn">Search</button> */}
                    </div>
                  </form>
                </div>
              </div>
            </section>

            {/* <div>
              <button
                className={`sch-btn ${selectedButton === "today" ? "active" : ""
                  }`} // Add 'active' class if selected
                onClick={() => handleButtonClick("today")}
              >
                Today
              </button>
              <button
                className={`sch-btn ${selectedButton === "yesterday" ? "active" : ""
                  }`} // Add 'active' class if selected
                onClick={() => handleButtonClick("yesterday")}
              >
                Tomorrow
              </button>
            </div> */}

            {/* <div
              className="col-12 col-sm-12 col-md-12 col-lg-12 mb-12 bg-white"
              style={{ marginBottom: "15px", padding: "11px" }}
            >
              <TableContainer sx={{ boxShadow: "none" }}>
                <Table sx={{ border: "1px solid #31876f33" }}>
                  <TableHead className="table-header">
                    <TableRow>
                      <TableCell
                        className="theader-cell"
                        sx={{ fontWeight: "bold", padding: "5px" }}
                      >
                        Trip Date
                      </TableCell>
                      <TableCell
                        className="theader-cell"
                        sx={{ fontWeight: "bold", padding: "5px" }}
                      >
                        No of Legs
                      </TableCell>
                      <TableCell
                        className="theader-cell"
                        sx={{ fontWeight: "bold", padding: "5px" }}
                      >
                        Schedule Type
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                          padding: "5px",
                          border: "1px solid #d5d2d2",
                          color: "#fff",
                          textAlign: "left",
                        }}
                      >
                        Driver Name
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                          padding: "5px",
                          border: "1px solid #d5d2d2",
                          color: "#fff",
                          textAlign: "left",
                        }}
                      >
                        Passenger Name
                      </TableCell>
                      <TableCell
                        className="theader-cell"
                        sx={{ fontWeight: "bold", padding: "5px" }}
                      >
                        Payer
                      </TableCell>
                      <TableCell
                        className="theader-cell"
                        sx={{ fontWeight: "bold", padding: "5px" }}
                      >
                        Pickup/Dropoff Details
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Array.isArray(scheduleDetails) &&
                      scheduleDetails.length > 0 ? (
                      (scheduleDetails || [])
                        .slice(0, 4)
                        .map((details, index) => (
                          <TableRow key={index}>
                            <TableCell className="maintenance-tbody-cell">
                              {dateFormat(details.schedule_date)}
                            </TableCell>
                            <TableCell className="maintenance-tbody-cell">
                              {details.no_of_leg}
                            </TableCell>
                            <TableCell className="maintenance-tbody-cell">
                              {details.is_upload_schedule === "0"
                                ? "Manual"
                                : "Spread Sheet"}
                            </TableCell>
                            <TableCell className="maintenance-tbody-cell">
                              {details.driver ? (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Avatar
                                    alt={details.driver.firstName}
                                    src=""
                                    style={{ marginRight: "10px" }}
                                  />
                                  <a
                                    href={
                                      details.driver?.user_role == 2
                                        ? `/home/profile/myProfile`
                                        : `/home/driver/profile/id?profilId=${Base64.encode(
                                          details.driver.driver_id
                                        )}`
                                    } // Replace with the correct route
                                    target="_blank" // Open in a new tab
                                    rel="noopener noreferrer" // Security best practice
                                    style={{
                                      textDecoration: "none",
                                      color: "#31876f",
                                    }} // Optional: Style the link
                                  >
                                    {details.driver.firstName &&
                                      details.driver.lastName
                                      ? details.driver.firstName +
                                      " " +
                                      details.driver.middleName +
                                      " " +
                                      details.driver.lastName
                                      : details.driver.fullName}
                                  </a>
                                </div>
                              ) : (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <button
                                    className="add-driver-button"
                                    onClick={() =>
                                      openModal(
                                        details.schedule_id,
                                        details?.schedule_date
                                      )
                                    }
                                  >
                                    Assign Driver
                                  </button>
                                </div>
                              )}
                            </TableCell>

                            <TableCell className="maintenance-tbody-cell">
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <Avatar
                                  alt={details.passenger?.firstName}
                                  src=""
                                  style={{ marginRight: "10px" }}
                                />
                                <a
                                  href={`/home/passenger/profile/id?profilId=${Base64.encode(
                                    details?.passenger?.passenger_id
                                  )}`} // Replace with the correct route
                                  target="_blank" // Open in a new tab
                                  rel="noopener noreferrer" // Security best practice
                                  style={{
                                    textDecoration: "none",
                                    color: "#31876f",
                                  }} // Optional: Style the link
                                >
                                  {details.passenger
                                    ? details.passenger?.firstName +
                                    " " +
                                    (details.passenger?.middleName ?? "") +
                                    " " +
                                    (details.passenger?.lastName ?? "") +
                                    "-" +
                                    details.passenger?.passenger?.pass_pmi_no
                                    : ""}
                                </a>
                              </div>
                            </TableCell>
                            <TableCell className="maintenance-tbody-cell">
                              {details.passenger?.passenger?.payers?.payer_name}
                            </TableCell>
                            <React.Fragment key={index}>
                              <TableCell className="maintenance-tbody-cell">
                                <button
                                  className="leg-details-btn"
                                  onClick={() => handleOpenPopup(details)}
                                >
                                  Click Here
                                </button>
                              </TableCell>
                            </React.Fragment>
                          </TableRow>
                        ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={7} style={{ textAlign: "center" }}>
                          No data available
                        </TableCell>
                      </TableRow>
                    )}
                    {scheduleDetails && scheduleDetails.length > 4 && (
                      <TableRow
                        style={{
                          cursor: "pointer",
                          backgroundColor: "#f1f1f1",
                        }}
                        onClick={() =>
                          navigate("/home/schedule/list", {
                            replace: true,
                            state: { buttonValue: selectedButton },
                          })
                        }
                      >
                        <TableCell
                          colSpan={7}
                          align="right"
                          style={{
                            border: "1px solid #d5d2d2",
                            color: "#31876f",
                            fontWeight: "bold",
                          }}
                        >
                          View More...
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </div> */}

            <div className="dashboard-list-wrapper">
              <div
                className="col-sm-6 col-md-4 col-lg-4 mb-5 bg-white"
                style={{ paddingBottom: "12px" }}
              >
                <div
                  style={{
                    color: "#31876f",
                    fontSize: "24px",
                    padding: "0px",
                    lineHeight: "1.6",
                  }}
                >
                  Today's Trips Details
                </div>
                <TableContainer sx={{ boxShadow: "none" }}>
                  <Table sx={{ border: "1px solid #31876f33" }}>
                    <TableHead className="table-header">
                      <TableRow>
                        <TableCell
                          colSpan={2}
                          className="tbl-cell"
                          sx={{ fontWeight: "bold", padding: "5px" }}
                        >
                          {"Trip Date - " + currentDateFormat(currentDate)}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          style={{
                            border: "1px solid #d5d2d2",
                            width: "50%",
                            textAlign: "left",
                          }}
                        >
                          Trips In Progress
                        </TableCell>
                        <TableCell className="tbody-cell">
                          {" "}
                          {`${tripProgressCount}`}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          style={{
                            border: "1px solid #d5d2d2",
                            width: "50%",
                            textAlign: "left",
                          }}
                        >
                          Trips Completed{" "}
                        </TableCell>
                        <TableCell className="tbody-cell">
                          {" "}
                          {` ${tripCompletedCount}`}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          style={{
                            border: "1px solid #d5d2d2",
                            width: "50%",
                            textAlign: "left",
                          }}
                        >
                          {" "}
                          Trips Pending
                        </TableCell>
                        <TableCell className="tbody-cell">
                          {" "}
                          {`${tripPendingCount}`}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          style={{
                            border: "1px solid #d5d2d2",
                            width: "50%",
                            textAlign: "left",
                          }}
                        >
                          {" "}
                          Trips Canceled
                        </TableCell>
                        <TableCell className="tbody-cell">
                          {tripCancelCount}{" "}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          style={{
                            border: "1px solid #d5d2d2",
                            width: "50%",
                            textAlign: "left",
                          }}
                        >
                          {" "}
                          Trips Total Amount
                        </TableCell>
                        <TableCell className="tbody-cell">
                          {" "}
                          {`$${tripsTotalAmount}`}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
              <div
                className="col-sm-6 col-md-4 col-lg-8 mb-5 bg-white"
                style={{ paddingBottom: "12px" }}
              >
                <div
                  style={{
                    color: "#31876f",
                    fontSize: "24px",
                    padding: "0px",
                    lineHeight: "1.6",
                  }}
                >
                  Vehicle Requires Maintenance
                </div>
                <TableContainer sx={{ boxShadow: "none" }}>
                  <Table sx={{ border: "1px solid #31876f33" }}>
                    <TableHead className="table-header">
                      <TableRow>
                        <TableCell
                          style={{
                            border: "1px solid #d5d2d2",
                            width: maintenanceVehicle.length !== 0 ? "90%" : "",
                            textAlign: "left",
                          }}
                          sx={{
                            fontWeight: "bold",
                            padding: "5px",
                            paddingLeft: "16px",
                            color: "#fff !important",
                          }}
                        >
                          Vehicle
                        </TableCell>
                        {/* <TableCell style={{ border: '1px solid #d5d2d2', width: '28%', textAlign: 'left' }} sx={{ fontWeight: 'bold', padding: '5px', color: '#fff !important' }}>Status</TableCell> */}
                        <TableCell
                          className="tbl-cell"
                          sx={{ fontWeight: "bold", padding: "5px" }}
                        >
                          Last Updated
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {maintenanceVehicle && maintenanceVehicle.length > 0
                        ? (maintenanceVehicle || [])
                          .slice(0, 4)
                          .map((vehicle, index) => (
                            <TableRow key={index}>
                              <TableCell
                                style={{
                                  border: "1px solid #d5d2d2",
                                  padding: "0px",
                                  paddingLeft: "16px",
                                }}
                              >
                                <a
                                  href={`/home/vehicle/report?vehicleName=${Base64.encode(
                                    vehicle.vehicle_name
                                  )}&vehicleId=${Base64.encode(
                                    vehicle.vehicle_id
                                  )}&activeMenu=vehicles`}
                                  style={{
                                    textDecoration: "none",
                                    color: "#31876f",
                                  }}
                                >
                                  {vehicle.vehicle_name} <br />
                                </a>
                                {(() => {
                                  const questions = vehicle.questions || [];
                                  const limit = 100;
                                  let charCount = 0;
                                  const elements = [];

                                  for (
                                    let i = 0;
                                    i < Math.min(2, questions.length);
                                    i++
                                  ) {
                                    const q = questions[i];
                                    const textLength =
                                      `${q.question.check_list} - ${q.status}, `
                                        .length;

                                    const isLast =
                                      i === Math.min(2, questions.length) - 1;
                                    elements.push(
                                      <span
                                        key={i}
                                        style={{
                                          display: "inline-block",
                                          marginRight: "6px",
                                        }}
                                      >
                                        <span
                                          style={{
                                            color: "#000",
                                            fontSize: "13px",
                                          }}
                                        >
                                          {q.question.check_list}
                                        </span>
                                        <span
                                          style={{
                                            color: "red",
                                            fontSize: "13px",
                                          }}
                                        >
                                          {" "}
                                          - {q.status}
                                        </span>
                                        {!isLast && ","}
                                      </span>
                                    );
                                  }

                                  return elements;
                                })()}
                              </TableCell>
                              {/* <TableCell style={{ border: '1px solid #d5d2d2' }}>
                             {(vehicle.questions || []).map(q => q.check_list).join(', ')}
                          </TableCell> */}
                              <TableCell className="maintenance-tbody-cell">
                                {dateFormat(vehicle.last_update_date)}
                              </TableCell>
                            </TableRow>
                          ))
                        : null}

                      {/* Add empty rows to maintain 7 rows */}
                      {Array.from({
                        length: 5 - (maintenanceVehicle?.length || 0),
                      }).map((_, index) => (
                        <TableRow key={`empty-${index}`}>
                          <TableCell
                            style={{
                              border: "1px solid #d5d2d2",
                              color: "grey",
                            }}
                          >
                            N/A
                          </TableCell>
                          {/* <TableCell style={{ border: '1px solid #d5d2d2', color: 'grey' }}>N/A</TableCell> */}
                          <TableCell
                            className="maintenance-tbody-cell"
                            style={{ color: "grey" }}
                          >
                            N/A
                          </TableCell>
                        </TableRow>
                      ))}
                      {/* Show Load More if there are more than 5 records */}
                      {maintenanceVehicle && maintenanceVehicle.length > 5 && (
                        <TableRow
                          style={{
                            cursor: "pointer",
                            backgroundColor: "#f1f1f1",
                          }}
                          onClick={() =>
                            navigate("/home/vehicle/list", { replace: true })
                          }
                        >
                          <TableCell
                            colSpan={3}
                            align="right"
                            style={{
                              border: "1px solid #d5d2d2",
                              color: "#31876f",
                              fontWeight: "bold",
                            }}
                          >
                            View More...
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </div>

            <div
              style={{
                color: "#31876f",
                fontSize: "24px",
                padding: "0px",
                lineHeight: "1.6",
              }}
            >
              Today’s Completed Trips
            </div>
            {<MultipleMapComponent routes={route} />}
          </div>
        </section>
      </div>
      <ReusableModal
        maxWidth="md"
        fullWidth={true}
        open={openPopup}
        onClose={handleClosePopup}
        title={
          <div
            style={{
              position: "relative",
              paddingBottom: "10px",
              borderBottom: "1px solid #ddd",
            }}
          >
            <h4 style={{ margin: 0, fontWeight: "normal" }}>Shedule Details</h4>
          </div>
        }
      >
        {popupData ? (
          <TableContainer sx={{ boxShadow: "none" }}>
            <Table sx={{ border: "1px solid #31876f33" }}>
              <TableHead className="table-header">
                <TableRow>
                  <TableCell
                    className="theader-cell"
                    sx={{ fontWeight: "bold", padding: "5px" }}
                  >
                    Leg
                  </TableCell>
                  <TableCell
                    style={{
                      border: "1px solid #d5d2d2",
                      width: "50%",
                      textAlign: "left",
                    }}
                    sx={{ fontWeight: "bold", padding: "5px", color: "#fff" }}
                  >
                    Pickup Address
                  </TableCell>
                  <TableCell
                    className="theader-cell"
                    sx={{ fontWeight: "bold", padding: "5px" }}
                  >
                    Pickup Time
                  </TableCell>
                  <TableCell
                    style={{
                      border: "1px solid #d5d2d2",
                      width: "50%",
                      textAlign: "left",
                    }}
                    sx={{ fontWeight: "bold", padding: "5px", color: "#fff" }}
                  >
                    DropOff Address
                  </TableCell>
                  <TableCell
                    className="theader-cell"
                    sx={{ fontWeight: "bold", padding: "5px" }}
                  >
                    DropOff Time
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {popupData.transData.map((leg, legArrayIndex) => (
                  <TableRow key={legArrayIndex}>
                    {/* <TableCell>{index + 1}</TableCell> */}
                    <TableCell className="maintenance-tbody-cell">
                      {" "}
                      {legArrayIndex + 1}
                    </TableCell>
                    <TableCell
                      style={{
                        border: "1px solid #d5d2d2",
                        width: "50%",
                        textAlign: "left",
                      }}
                    >
                      {leg.pickupLocation?.pickup_location &&
                        leg.pickupLocation.pickup_location.replace(/,,/, "") +
                        ", "}
                      {leg.pickupLocation?.pickup_address &&
                        leg.pickupLocation.pickup_address.replace(/,,/, "") +
                        ", "}
                      {leg.pickupLocation?.pickup_city &&
                        leg.pickupLocation.pickup_city.replace(/,,/, "") + ", "}
                      {leg?.pickupLocation?.state_master_list
                        ?.pickup_state_name &&
                        leg?.pickupLocation?.state_master_list?.pickup_state_name.replace(
                          /,,/,
                          ""
                        ) + ", "}
                      {leg?.pickupLocation?.pickup_zip || ""}
                    </TableCell>
                    <TableCell className="maintenance-tbody-cell">
                      {leg.pick_up_time}
                    </TableCell>
                    <TableCell
                      style={{
                        border: "1px solid #d5d2d2",
                        width: "50%",
                        textAlign: "left",
                      }}
                    >
                      {leg.dropoffLocation?.dropoff_location &&
                        leg.dropoffLocation?.dropoff_location.replace(
                          /,,/,
                          ""
                        ) + ", "}
                      {leg.dropoffLocation?.dropoff_address &&
                        leg.dropoffLocation?.dropoff_address.replace(/,,/, "") +
                        ", "}
                      {leg.dropoffLocation?.dropoff_city &&
                        leg.dropoffLocation?.dropoff_city.replace(/,,/, "") +
                        ", "}
                      {leg?.dropoffLocation?.state_master_list
                        ?.dropOff_state_name &&
                        leg?.dropoffLocation?.state_master_list?.dropOff_state_name.replace(
                          /,,/,
                          ""
                        ) + ", "}
                      {leg.dropoffLocation?.dropoff_zip}
                    </TableCell>
                    <TableCell className="maintenance-tbody-cell">
                      {leg.drop_off_time}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <div>No legs available</div> // Handle the case where there are no legs
        )}
      </ReusableModal>

      <DriverListModal
        visible={isModalVisible}
        onHide={closeModal}
        title="Drivers List"
        driverList={driverList}
        setSelectedDriverId={setSelectedDriverId}
        selectedDriverId={selectedDriverId}
        onSave={driverSaveForm}
        isClicked={isClicked}
      />
    </>
  );
}

export default DashboardNew;
